import useExternalActions from "security-content/hooks/useExternalActions";
export default { useExternalActions };
